module.exports = __webpack_public_path__ + "static/img/spiked-rebar_256.914249a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/spiked-rebar_256.png
// module id = 72f4
// module chunks = 0